(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8061],{

/***/ 23435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerships",
      function () {
        return __webpack_require__(35344);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ PartnershipsFeature; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/intro/intro.module.css
var intro_module = __webpack_require__(60867);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/intro/intro.tsx






const Intro = (blok)=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const [CTA] = blok.CTA || [];
    // Doing this because it complains if we add target directly, however it works
    const link = {
        target: "_blank"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (intro_module_default()).container,
        children: [
            (0,shared_src/* renderWithResolver */.be)(blok.body),
            CTA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                element: "a",
                ...link,
                href: CTA.url,
                onClick: ()=>{
                    trackEvent({
                        eventName: `Partnerships - cinch presents site click`,
                        data: {
                            event: {
                                name: "click",
                                category: "parnerships pages",
                                action: "partnerships tags",
                                label: `Visit cinch presents site`
                            }
                        },
                        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
                    });
                },
                classNames: {
                    button: (intro_module_default()).button
                },
                children: CTA.text
            }) : null
        ]
    });
};
/* harmony default export */ var intro = (Intro);

// EXTERNAL MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/image-carousel/image-carousel.module.css
var image_carousel_module = __webpack_require__(66358);
var image_carousel_module_default = /*#__PURE__*/__webpack_require__.n(image_carousel_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/image-carousel/image-carousel.tsx




const carouselSettings = {
    name: "partnerships-images",
    ariaLabels: {
        previous: "Go to previous slide",
        next: "Go to next slide"
    },
    swiperSettings: {
        spaceBetween: 0,
        slidesPerView: 1
    }
};
const ImageCarousel = ({ images  })=>{
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Carousel */.lr, {
                name: carouselSettings.name,
                swiperSettings: carouselSettings.swiperSettings,
                customClassNames: {
                    carousel: (image_carousel_module_default()).carousel
                },
                children: (ref = images.filter((image)=>{
                    return image === null || image === void 0 ? void 0 : image.filename;
                })) === null || ref === void 0 ? void 0 : ref.map((image, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (image_carousel_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                layout: "fill",
                                objectPosition: "40%",
                                objectFit: "cover",
                                // This is a full width image and therefore the largest contentful paint LCP.
                                // Eagerly load the first image and lazy load the others.
                                priority: idx === 0
                            })
                        })
                    }, image.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* CarouselControls */.J8, {
                customClassNames: (image_carousel_module_default()).carouselControls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselPagination */.Jj, {
                        name: carouselSettings.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselNavigation */.Pn, {
                        name: carouselSettings.name,
                        ariaLabels: carouselSettings.ariaLabels,
                        customClassNames: {
                            prevButton: (image_carousel_module_default()).carouselNavButton,
                            nextButton: (image_carousel_module_default()).carouselNavButton
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var image_carousel = (ImageCarousel);

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../node_modules/react-slidedown/lib/slidedown.js
var slidedown = __webpack_require__(84197);
// EXTERNAL MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/partners-overview/partner-card/partner-card.module.css
var partner_card_module = __webpack_require__(59632);
var partner_card_module_default = /*#__PURE__*/__webpack_require__.n(partner_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/partners-overview/partner-card/partner-card.tsx




const PartnerCard = ({ body , heading , logo , url , innerRef  })=>{
    const [link] = url || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (partner_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partner_card_module_default()).logoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: logo.filename,
                    alt: logo.alt ?? undefined,
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (partner_card_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h3",
                        className: (partner_card_module_default()).heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (partner_card_module_default()).text,
                        children: body
                    }),
                    link.url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: link.url.cached_url,
                        className: (partner_card_module_default()).link,
                        target: "_blank",
                        ref: innerRef,
                        rel: "noreferrer",
                        "aria-label": heading === "TRNSMT" ? "Visit Transmit official site" : "",
                        children: [
                            link.text,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                name: "arrow-right",
                                className: (partner_card_module_default()).externalLinkIcon
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var partner_card = (PartnerCard);

// EXTERNAL MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/partners-overview/partners-overview.module.css
var partners_overview_module = __webpack_require__(91286);
var partners_overview_module_default = /*#__PURE__*/__webpack_require__.n(partners_overview_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/partners-overview/partners-overview.tsx









const DEFAULT_PARTNER_CARDS_LENGTH = 5;
const PartnersOverview = (blok)=>{
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const ref = (0,react.useRef)(null);
    const handleClick = ()=>{
        var ref1, ref2, ref3;
        isExpanded ? (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.scrollIntoView) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, {
            block: "center"
        }) : (ref3 = ref.current) === null || ref3 === void 0 ? void 0 : ref3.focus();
        setIsExpanded((prevState)=>!prevState);
    };
    const partnerCards = isExpanded ? blok.partners : blok.partners.slice(0, DEFAULT_PARTNER_CARDS_LENGTH);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (partners_overview_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (partners_overview_module_default()).heading,
                children: blok.heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(slidedown/* SlideDown */.sJ, {
                as: "ul",
                className: (partners_overview_module_default()).listContainer,
                "data-expanded": isExpanded,
                children: partnerCards.map((partner, idx)=>/*#__PURE__*/ (0,react.createElement)(partner_card, {
                        ...partner,
                        key: partner._uid,
                        innerRef: idx === DEFAULT_PARTNER_CARDS_LENGTH - 1 ? ref : undefined
                    }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Secondary */.T7, {
                classNames: {
                    button: (partners_overview_module_default()).button
                },
                element: "button",
                onClick: ()=>handleClick(),
                children: [
                    `Show ${isExpanded ? "fewer" : "all"} partnerships`,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                        name: "chevron-down",
                        size: 16,
                        className: classnames_default()((partners_overview_module_default()).chevronIcon, {
                            [(partners_overview_module_default()).chevronIconRotateUp]: isExpanded
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var partners_overview = (PartnersOverview);

;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/components/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/data/storyblok-renderer-map.ts

const storyblokComponents = {
    PartnershipsIntro: intro,
    PartnershipsPartnerOverviewList: partners_overview
};

// EXTERNAL MODULE: ../../../libs/landing/feature-partnerships/src/lib/partnerships/partnerships.module.css
var partnerships_module = __webpack_require__(60202);
var partnerships_module_default = /*#__PURE__*/__webpack_require__.n(partnerships_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/partnerships/partnerships.tsx








function PartnershipsFeature({ story , preview , generatedAt  }) {
    var ref, ref1;
    const typedStory = story;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story: typedStory,
        enableBridge: preview
    });
    const image = content.Image;
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Partnerships - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                                block: content.Intro,
                                components: storyblokComponents
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                                block: content.Partners,
                                components: storyblokComponents
                            })
                        ]
                    }),
                    (content === null || content === void 0 ? void 0 : (ref1 = content.ImageCarousel) === null || ref1 === void 0 ? void 0 : ref1.some((image)=>image.filename)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isFluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_carousel, {
                            images: content === null || content === void 0 ? void 0 : content.ImageCarousel
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (partnerships_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                layout: "intrinsic",
                                width: "801",
                                height: "481",
                                objectFit: "contain"
                            })
                        }) : null
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var partnerships = ((/* unused pure expression or super */ null && (PartnershipsFeature)));

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/lib/partnerships/get-static-props.ts


async function getStaticProps({ preview =false  }) {
    try {
        var ref, ref1;
        const story = await getStoryBySlug("partnerships", {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Unable to fetch `partnerships` story from storyblok");
        }
        const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.Hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        setTag("response.code", 200);
        setTag("page.name", "partnerships");
        setTag("page.rendered", "ISR");
        setTag("page.params", JSON.stringify({
            preview
        }, null, 2));
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: HeroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            tagError(error);
        }
        return {
            props: {
                story: null,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: [],
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    }
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-partnerships/src/index.ts



;// CONCATENATED MODULE: ./pages/partnerships.tsx
var __N_SSG = true;



/***/ }),

/***/ 66358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"image-carousel_imageWrapper__dWupa","carousel":"image-carousel_carousel__OmWDm","carouselControls":"image-carousel_carouselControls__AO8_f","carouselNavButton":"image-carousel_carouselNavButton__BlUF8"};

/***/ }),

/***/ 60867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"intro_container__IXUNA","paragraph":"intro_paragraph__LxVmg","button":"intro_button__aIaVJ","externalIconSvg":"intro_externalIconSvg__905ZR"};

/***/ }),

/***/ 59632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"partner-card_container__S1SJt","inner":"partner-card_inner__iirsL","heading":"partner-card_heading__Qg718","text":"partner-card_text__k_6ls","link":"partner-card_link__yplfL","externalLinkIcon":"partner-card_externalLinkIcon__pHieW","logoWrapper":"partner-card_logoWrapper__Qk1FR"};

/***/ }),

/***/ 91286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"partners-overview_container__gfQwv","listContainer":"partners-overview_listContainer__OWldo","listItem":"partners-overview_listItem__SoY5s","button":"partners-overview_button__8nsAc","chevronIcon":"partners-overview_chevronIcon__l1r7A","chevronIconRotateUp":"partners-overview_chevronIconRotateUp__MwuBG"};

/***/ }),

/***/ 60202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"partnerships_imageWrapper__9jBpR"};

/***/ }),

/***/ 84197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.sJ = void 0;
var tslib_1 = __webpack_require__(31191);
var react_1 = (0, tslib_1.__importStar)(__webpack_require__(32735));
var SlideDownContent = (function (_super) {
    (0, tslib_1.__extends)(SlideDownContent, _super);
    function SlideDownContent(props) {
        var _this = _super.call(this, props) || this;
        _this.outerRef = null;
        _this.handleRef = function (ref) {
            _this.outerRef = ref;
            if (_this.props.forwardedRef) {
                if (typeof _this.props.forwardedRef === 'function') {
                    _this.props.forwardedRef(ref);
                }
                else if (typeof _this.props.forwardedRef === 'object') {
                    var forwardedRef = _this.props.forwardedRef;
                    forwardedRef.current = ref;
                }
                else {
                    throw new Error("Invalid forwardedRef ".concat(_this.props.forwardedRef));
                }
            }
        };
        _this.handleTransitionEnd = function (evt) {
            if ((evt.target === _this.outerRef) && (evt.propertyName === 'height')) {
                if (_this.state.childrenLeaving) {
                    _this.setState({ children: null, childrenLeaving: false }, function () { return _this.endTransition(); });
                }
                else {
                    _this.endTransition();
                }
            }
        };
        _this.state = {
            children: props.children,
            childrenLeaving: false
        };
        return _this;
    }
    SlideDownContent.prototype.componentDidMount = function () {
        if (this.outerRef) {
            if (this.props.closed || !this.props.children) {
                this.outerRef.classList.add('closed');
                this.outerRef.style.height = '0px';
            }
            else if (this.props.transitionOnAppear) {
                this.startTransition('0px');
            }
            else {
                this.outerRef.style.height = 'auto';
            }
        }
    };
    SlideDownContent.prototype.getSnapshotBeforeUpdate = function () {
        return this.outerRef ? this.outerRef.getBoundingClientRect().height + 'px' : null;
    };
    SlideDownContent.getDerivedStateFromProps = function (props, state) {
        if (props.children) {
            return {
                children: props.children,
                childrenLeaving: false
            };
        }
        else if (state.children) {
            return {
                children: state.children,
                childrenLeaving: true
            };
        }
        else {
            return null;
        }
    };
    SlideDownContent.prototype.componentDidUpdate = function (_prevProps, _prevState, snapshot) {
        if (this.outerRef) {
            this.startTransition(snapshot);
        }
    };
    SlideDownContent.prototype.startTransition = function (prevHeight) {
        var endHeight = '0px';
        if (!this.props.closed && !this.state.childrenLeaving && this.state.children) {
            this.outerRef.classList.remove('closed');
            this.outerRef.style.height = 'auto';
            endHeight = getComputedStyle(this.outerRef).height;
        }
        if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
            this.outerRef.classList.add('transitioning');
            this.outerRef.style.height = prevHeight;
            this.outerRef.offsetHeight;
            this.outerRef.style.transitionProperty = 'height';
            this.outerRef.style.height = endHeight;
        }
    };
    SlideDownContent.prototype.endTransition = function () {
        this.outerRef.classList.remove('transitioning');
        this.outerRef.style.transitionProperty = 'none';
        this.outerRef.style.height = this.props.closed ? '0px' : 'auto';
        if (this.props.closed || !this.state.children) {
            this.outerRef.classList.add('closed');
        }
    };
    SlideDownContent.prototype.render = function () {
        var _a = this.props, _b = _a.as, as = _b === void 0 ? 'div' : _b, children = _a.children, className = _a.className, closed = _a.closed, transitionOnAppear = _a.transitionOnAppear, forwardedRef = _a.forwardedRef, rest = (0, tslib_1.__rest)(_a, ["as", "children", "className", "closed", "transitionOnAppear", "forwardedRef"]);
        var containerClassName = className ? 'react-slidedown ' + className : 'react-slidedown';
        return react_1.default.createElement(as, (0, tslib_1.__assign)({ ref: this.handleRef, className: containerClassName, onTransitionEnd: this.handleTransitionEnd }, rest), this.state.children);
    };
    SlideDownContent.defaultProps = {
        transitionOnAppear: true,
        closed: false
    };
    return SlideDownContent;
}(react_1.Component));
exports.sJ = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(SlideDownContent, (0, tslib_1.__assign)({}, props, { forwardedRef: ref }))); });
__webpack_unused_export__ = exports.sJ;
//# sourceMappingURL=slidedown.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(23435); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);